"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var AffilatesList_1 = require("./component/AffilatesList");
var AffilateEditor_1 = require("./component/AffilateEditor");
var AffilateAdminsAccessList_1 = require("./component/AffilateAdminsAccessList");
var AffilateBannerTPLEditor_1 = require("./component/AffilateBannerTPLEditor");
var AffilateBrandingTPLEditor_1 = require("./component/AffilateBrandingTPLEditor");
var AffilateConfig_1 = require("./component/AffilateConfig");
var AffilateSmtpCfgEditor_1 = require("./component/AffilateSmtpCfgEditor");
var PParAffilatesList = /** @class */ (function (_super) {
    __extends(PParAffilatesList, _super);
    function PParAffilatesList(props) {
        return _super.call(this, props) || this;
    }
    PParAffilatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PParAffilatesList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PParAffilatesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PParAffilatesList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PParAffilatesList.prototype.onAffilateConfigClick = function (id) {
        this.setState({ edit_mode: "CONFIG", record: id });
    };
    PParAffilatesList.prototype.onAccessConfigClick = function (id) {
        this.setState({ edit_mode: "ACCESS-CONFIG", record: id });
    };
    PParAffilatesList.prototype.onSMTPConfigClick = function (val) {
        this.setState({ edit_mode: "SMTP-CONFIG", record: val });
    };
    PParAffilatesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PParAffilatesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PParAffilatesList.prototype.onEditBannerTemplateClick = function (id) {
        var _this = this;
        this.props.data.GetBannerTemplate(id.key, function (base64Template) {
            _this.setState({ edit_mode: "EDIT-BANNER-TEMPLATE", record: id, base64_banner_template: base64Template });
        });
    };
    PParAffilatesList.prototype.onEditBrandingTemplateClick = function (id) {
        var _this = this;
        this.props.data.GetBrandingTemplate(id.key, function (base64Template) {
            _this.setState({ edit_mode: "EDIT-BRANDING-TEMPLATE", record: id, base64_branding_template: base64Template });
        });
    };
    PParAffilatesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(AffilateEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(AffilateEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "ACCESS-CONFIG") {
            return (React.createElement(AffilateAdminsAccessList_1.default, { data: this.props.dataAccess, state: this.props.state, record: this.state.record, onGoBackClick: this.onGoBackClick.bind(this), dialog: this.props.dialog }));
        }
        if (this.state.edit_mode === "SMTP-CONFIG") {
            return (React.createElement(AffilateSmtpCfgEditor_1.default, { onGoBack: this.onGoBackClick.bind(this), record: this.state.record, state: this.props.state, data: this.props.dataSmtp }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(AffilatesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onAccessConfigClick: this.onAccessConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onEditBannerTemplateClick: this.onEditBannerTemplateClick.bind(this), onEditBrandingTemplateClick: this.onEditBrandingTemplateClick.bind(this), onAffilateConfigClick: this.onAffilateConfigClick.bind(this), onSMTPConfigClick: this.onSMTPConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT-BANNER-TEMPLATE") {
            return (React.createElement(AffilateBannerTPLEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), textBase64: this.state.base64_banner_template }));
        }
        if (this.state.edit_mode === "EDIT-BRANDING-TEMPLATE") {
            return (React.createElement(AffilateBrandingTPLEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), textBase64: this.state.base64_branding_template }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(AffilateConfig_1.default, { state: this.props.state, record: this.state.record, onGoBackClick: this.onGoBackClick.bind(this), listAffilateCurrency: this.props.listAffilateCurrency, listAffilateLanguage: this.props.listAffilateLanguage, listAffilateOffers: this.props.listAffilateOffers, listAffilateBrands: this.props.listAffilateBrands, listAvailAppCurrency: this.props.listAvailAppCurrency, listAvailAppLanguages: this.props.listAvailAppLanguages, listAvailAffilateOffers: this.props.listAvailAffilateOffers, listAvailBrands: this.props.listAvailBrands, 
                //
                listAffilateCountry: this.props.listAffilateCountry, listAffilatePayouts: this.props.listAffilatePayouts, listAvailAppCountry: this.props.listAvailAppCountry, listAvailAppPayout: this.props.listAvailAppPayout, 
                //
                brandsList: this.props.ListAffilatesBrandsAvail, promoForBrandsList: this.props.ListPromoCodeTemplatesForBrandsAvail, promoData: this.props.ListAffilatesPromoCodeTemplates, 
                //
                listAvailEMailTemplateActions: this.props.listAvailEMailTemplateActions, affilateEmailTemplates: this.props.affilateEmailTemplates, affilateEmailTemplateImages: this.props.affilateEmailTemplateImages, dialogSelectImage: this.props.dialogSelectImage }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PParAffilatesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PParAffilatesList.getPageDescription = function (state) {
        return {
            icon: "traffic-light",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_affilates + "-id",
            itemTitle: "П.Программы",
            route: routes_1.routes.page_par_affilates,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PParAffilatesList;
}(React.Component));
exports.default = PParAffilatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/PParAffilatesList.tsx
// module id = 2009
// module chunks = 0